import { render, staticRenderFns } from "./BusinessDirectoryDangerZone.vue?vue&type=template&id=7d450a61&"
import script from "./BusinessDirectoryDangerZone.vue?vue&type=script&lang=js&"
export * from "./BusinessDirectoryDangerZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports